module.exports = __webpack_public_path__ + "static/media/test15_3.6bfac834.png";